import { render, staticRenderFns } from "./ProtocolDocumentList.vue?vue&type=template&id=1f752d7e&"
import script from "./ProtocolDocumentList.vue?vue&type=script&lang=js&"
export * from "./ProtocolDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports